module.exports = vendor_49736c16ac25d2e17270;


//////////////////
// WEBPACK FOOTER
// external "vendor_49736c16ac25d2e17270"
// module id = 35
// module chunks = 0